// Change this import and DEFAULT_GAME_VERSION to change the game data version the code is using

import GameData from './live';

export const DEFAULT_GAME_VERSION = 'live';

// this might not be needed since live/beta is branch based nowadays
export const BETA_GAME_VERSION = 'live';

export default GameData;
